module.exports = __webpack_public_path__ + "img/GrowthStage.a3aa8b88.png";